import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../../base';

export class Positions extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/positions`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.positions.forEach((record: any) => this.processRecord(record)))
    )
  }

  private processRecord(record: any) {
    record.strike = new BigNumber(record.strike).fromDecimal();
    record.size = new BigNumber(record.size).fromDecimal();
    record.notional = new BigNumber(record.notional).fromDecimal();
    record.avg = record.notional.div(record.size).abs();
  }
}
